const PipelineAnalytics = () => {
  const omniDashboardUrl =
    import.meta.env.VITE_OMNI_PIPELINE_ANALYTICS_URL ||
    'https://starmountaincapital.embed-omniapp.co/dashboards/b520947d';

  return (
    <div className="h-full w-full bg-white dark:bg-gray-900">
      <iframe
        allow="camera; microphone; geolocation; clipboard-write"
        className="h-full w-full border-none"
        src={omniDashboardUrl}
        title="Pipeline Analytics"
      />
    </div>
  );
};

export default PipelineAnalytics;
